/**
 * Format seconds to HH:MM:SS display (e.g., "01:23:45")
 */
export const formatSecondsToFullTime = (seconds) => {
    if (typeof seconds !== 'number') return seconds
    const pad = (n) => n.toString().padStart(2, '0')
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const sec = seconds % 60
    return `${pad(h)}:${pad(m)}:${pad(sec)}`
}

/**
 * Format seconds to human-readable duration (e.g., "2h 15m 30s")
 */
export const formatDuration = (totalSeconds) => {
    const h = Math.floor(totalSeconds / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)
    const s = totalSeconds % 60
    if (h > 0) return `${h}h ${m}m ${s}s`
    if (m > 0) return `${m}m ${s}s`
    return `${s}s`
}

/**
 * Format ISO timestamp to locale string
 */
export const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp)
    return date.toLocaleString()
}

/**
 * Format username with fallback for anonymous users
 */
export const formatUser = (user) => {
    return user ? user : 'Anonymous'
}
